import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { rateCardUpdateFailure, rateCardUpdateSuccess } from '../../actions/rateCardActions/rateCardUpdateActions';
import store from '../../configStore';

function* rateCardUpdate({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.updateRateCard,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("UPDATE_RATE_CARD_SUCCESS status :", response.data.status);
        console.log("UPDATE_RATE_CARD_SUCCESS data :", response.data.response);
        console.log("UPDATE_RATE_CARD_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            rateCardUpdateSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("UPDATE_RATE_CARD_FAILURE status :", error?.response?.status);
        console.log("UPDATE_RATE_CARD_FAILURE data:", error?.response?.data);
        console.log("UPDATE_RATE_CARD_FAILURE error :", error);
        console.log('====================================');
        yield put(rateCardUpdateFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* rateCardUpdateSaga() {
    yield takeLatest(actionTypes.UPDATE_RATE_CARD_REQUEST, rateCardUpdate);
}

export default rateCardUpdateSaga;
